import { HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY, HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE } from '@atlassian/hub-element-placeholder';
export var getSectionExtensionContents = function getSectionExtensionContents(_ref) {
  var header = _ref.header,
    subHeader = _ref.subHeader,
    placeholderTitle = _ref.placeholderTitle;
  return [{
    type: 'extensionFrame',
    content: [{
      type: 'heading',
      attrs: {
        level: 1,
        localId: null
      },
      content: [{
        type: 'text',
        text: "".concat(header)
      }]
    }, {
      type: 'paragraph',
      attrs: {
        localId: null
      },
      content: [{
        type: 'text',
        text: "".concat(subHeader)
      }]
    }, {
      type: 'paragraph',
      attrs: {
        localId: null
      }
    }, {
      type: 'extension',
      attrs: {
        extensionKey: HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY,
        extensionType: HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE,
        parameters: {
          extensionTitle: placeholderTitle
        },
        text: null,
        layout: 'default',
        localId: null
      }
    }]
  }];
};